import { Button } from "@govlaunch/core";
import * as palette from "@govlaunch/palette";
import React from "react";
import { FormattedMessage } from "react-intl";
import { IStripePlanFieldsFragment } from "~/lib/queries/fragments/__generated__/StripePlanFields.generated";
import IntlDateTime from "~/src/shared/components/IntlDateTime";
import mediaQueries from "~/components/mediaQueries";
import FromPlanOption from "~/components/makers/FromPlanOption";
import ToBasicPlanOption from "~/components/makers/ToBasicPlanOption";
import ToPlanOption from "~/components/makers/ToPlanOption";

interface IComparePlansBeforeChangingProps {
  fromPlan: IStripePlanFieldsFragment;
  toPlan: IStripePlanFieldsFragment | "BASIC";
  onConfirm: () => void;
  onCancel: () => void;
}

export default function ComparePlansBeforeChanging({
  fromPlan,
  toPlan,
  onConfirm,
  onCancel,
}: IComparePlansBeforeChangingProps) {
  return (
    <div
      css={{
        display: "grid",
        gridRowGap: 20,
        padding: 20,
        backgroundColor: palette.white,
        border: `solid 1px ${palette.lightestGray}`,
        borderRadius: 4,
      }}
    >
      <div
        css={{
          display: "grid",
          gridRowGap: 4,
        }}
      >
        <h2
          css={{
            margin: 0,
          }}
        >
          <FormattedMessage defaultMessage="Proposed Changes" id="HsxnxF" />
        </h2>

        <p
          css={{
            margin: 0,
            color: palette.mediumGray,
            fontSize: 14,
            lineHeight: 1.33,
          }}
        >
          <FormattedMessage defaultMessage="Before we continue — compare what you're changing to." id="w6sv2+" />
        </p>
      </div>

      <div
        css={mediaQueries({
          display: "grid",
          gridRowGap: 30,
          gridColumnGap: 30,
          gridTemplateColumns: ["1fr", "1fr", "1fr", "1fr 1fr"],
        })}
      >
        <FromPlanOption fromPlan={fromPlan} />

        {toPlan === "BASIC" ? <ToBasicPlanOption /> : <ToPlanOption toPlan={toPlan} />}
      </div>

      <div>
        <p
          css={{
            fontSize: 14,
            lineHeight: 1.33,
            fontWeight: 500,
            color: palette.text,
          }}
        >
          *<FormattedMessage defaultMessage="Account plan will switch starting" id="WW27Jn" />{" "}
          <IntlDateTime value={fromPlan.changeDetails.proratePaymentDueDate || new Date()} />
        </p>
      </div>

      <div
        css={mediaQueries({
          justifyContent: "center",
          display: "grid",
          gridTemplateColumns: ["1fr", "1fr", "1fr", "1fr 1fr"],
          gridColumnGap: 20,
          gridRowGap: 20,
        })}
      >
        <Button color={palette.innovatorBlue} onClick={onConfirm}>
          <FormattedMessage defaultMessage="I want to change" id="FFUlbw" />
        </Button>

        <Button color={palette.darkGray} theme="secondary" onClick={onCancel}>
          <FormattedMessage defaultMessage="Cancel" id="47FYwb" />
        </Button>
      </div>
    </div>
  );
}
